module.exports = __webpack_public_path__ + "4c52b2a5cf42e5aef929ded16cdd7705.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KI.svg
// module id = n1tF
// module chunks = 0